
function loadScript( url, callback ) {
  var script = document.createElement( "script" )
  script.type = "text/javascript";
  if(script.readyState) {  // only required for IE <9
    script.onreadystatechange = function() {
      if ( script.readyState === "loaded" || script.readyState === "complete" ) {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {  //Others
    script.onload = function() {
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName( "head" )[0].appendChild( script );
}

function getScript(source, callback) {
    var script = document.createElement('script');
    var prior = document.getElementsByTagName('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = function( _, isAbort ) {
        if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
            script.onload = script.onreadystatechange = null;
            script = undefined;

            if(!isAbort && callback) setTimeout(callback, 0);
        }
    };

    script.src = source;
    prior.parentNode.insertBefore(script, prior);
}
function insertScript(url) {
    var script = document.createElement('script');
    script.id = 'id1';
    script.src = url;
    document.head.appendChild(script);
}
function insertCss(url) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
}


var myAppJavaScript = function($){
    if (document.documentElement.innerHTML.includes("data-aht-brand-widget-id")) {
      insertScript("//cdn.shopify.com/s/files/1/0522/5476/9330/t/5/assets/aht-brand-widget.js?v=27757487522465748841611639023");
      insertCss("https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css");
      insertCss("https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css");
      insertCss("//cdn.shopify.com/s/files/1/0522/5476/9330/t/5/assets/aht-brand-widget.css?v=142077740954494729821611639234");
      insertCss("//cdn.shopify.com/s/files/1/0522/5476/9330/t/5/assets/aht-brand-widget-main.scss.css?v=19766395453188839591611638861");
      insertScript("//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js");
    };   
};

if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery = jQuery.noConflict(true);
    myAppJavaScript(jQuery);
  });
} else {
  myAppJavaScript(jQuery);
}


    